import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  AlertColor,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableContainer,
  Tooltip,
} from '@mui/material';
import { Box } from '@mui/system';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import TitleText from '../../components/formlib/TitleText';
import CustomBackArrow from '../../components/imagepickers/backArrow';
import { ReactComponent as DPHLogo } from '../../assets/images/dphLogo.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/infoIcon.svg';
import { ReactComponent as AddNew } from '../../assets/images/Plus.svg';
import { ReactComponent as File } from '../../assets/images/file.svg';
import { ReactComponent as WaningInfoIcon } from '../../assets/images/infoIcon1.svg';
import MediumTypography from '../../components/formlib/MediumTypography';
import SingleLine from '../../components/formlib/SingleLine';
import ProgramPanel from '../../components/forms/ProgramPanel';
import { convertGenderToFrontend } from '../../utils/genderUtil';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import CommentTextbox from '../../components/formlib/CommentTextbox';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import CustomRadioButton from '../../components/formlib/CustomRadioButton';
import dayjs, { Dayjs } from 'dayjs';
import AutocompleteSearch from '../../components/formlib/AutocompleteSearch';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import { HeadCell, TableHeader } from '../../components/formlib/TableHeader';
import Textinput from '../../components/formlib/Textinput';
import {
  createMainIfsp,
  deleteIfspMembers,
  downloadMainIfsp,
  EmployeeListType,
  getIfsp,
  getTBRPreRequisite,
  initiateIfsp,
  updateIfsp,
  uploadIfspToTBR,
} from '../../services/ifspClient/IfspApi';
import TranslateWidget, { isOtherLanguage } from '../../TranslateWidget';
import { Formik, FormikProps, useFormikContext } from 'formik';
import * as yup from 'yup';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import { employeeRoles, OptionType } from '../../utils/type';
import { getClientDocumentFileName } from '../../utils/fileUtils';
import {
  ApiError,
  ApiMessage,
  isCustomError,
} from '../../services/ApiResponseHandler';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import ModalPopup from '../../components/formlib/ModalPopup';
import { LookUpContext } from '../../context/LookUpContextProvider';
import {
  IfspClientDetailsType,
  MemberType,
  setIfspClientDetails,
  updateIfspClientDetails,
  updateOriginalIfspClientDetails,
} from '../../redux/features/ifsp/ifspClientDetailsSlice';
import IfspTabNavigationComponent from './IfspNavBar/IfspTabNavigationComponent';
import IfspMembersTableRow from './IfspMembersTableRow';
import { v4 as uuidv4 } from 'uuid';
import { datePickerMinDateMaxDateValidate } from '../../utils/dateUtil';
import { useIfspUnsavedChanges } from './ifspUnsavedChanges';
import EmptyScreen from '../../components/shared/EmptyScreen';
import { useIfspClientInfoValidationCheckToSubmit } from './ifspComponents/ifspClientInfoValidationCheck';
import { updateIfspPermission } from '../../redux/features/ifsp/ifspPermissionSlice';
import InformationModal from '../ifsp/InformationModal';
import { FACESHEET, IFSP_REVIEW_ROUTE_NAME } from '../../routes/Routing';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import { useLocation, useNavigate } from 'react-router';
import IfspTBRCheckModal from './ifspComponents/IfspTBRCheckModal';
import { setTBRPreRequisite } from '../../redux/features/ifsp/ifspTBRPreRequisiteSlice';
import ShareDownloadModal from '../../components/formlib/modal/ShareDownloadModal';
import LanguageSelectionDialog from '../../components/shared/LanguageSelectionDialog';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import {
  REFERRAL_PROGRAM_KEY,
  REFERRAL_STATUS_KEY,
} from '../../services/Constant';
import LazyAutocompleteSearch from '../../components/formlib/LazyAutocompleteSearch';
import { getAllEmployeeByName } from '../../services/configApi/employees/employeeServices';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { updateIfspUnsavedFields } from '../../redux/features/ifsp/ifspUnsavedFieldSlice';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const info =
  'The Individualized Family Service Plan (IFSP) is a working document that outlines the Early Intervention (EI) services to be provided. The initial IFSP (based on a timely and comprehensive multidisciplinary evaluation and assessment) is completed within 45 days of referral. The plan is developed collaboratively among IFSP Team Members - including parents, caregivers, EI staff, Specialty Services Provider (SSP) staff and/or others, as needed. Participants in the development of the IFSP may also include community representatives, extended family members, and others as requested by the parent if feasible to do so. The EI Service Coordinator is responsible for implementing the plan, preparing for ongoing IFSP meetings, and meeting state and federal timelines.';

export type TBRPreRequisiteType = {
  ifspId: string;
  tbrIfspId: number;
  isTransitionChecked: boolean;
  isAlreadyTransitionChecked?: boolean;
  isServiceDeliveryChecked: boolean;
  isAlreadyServiceDeliveryChecked?: boolean;
  isCommonAreaChecked: boolean;
  isAlreadyCommonAreaChecked?: boolean;
  commonAreaReadyToUpload: boolean;
  isOutcomeChecked: boolean;
  isAlreadyOutcomeChecked?: boolean;
  outcomeReadyToUpload: boolean;
  serviceDeliveryReadyToUpload: boolean;
  transitionReadyToUpload: boolean;
  pendingUploadEvaluationToTbr: boolean;
};

export type MemberFormType = {
  memberType: MemberType;
  guardianName: OptionType;
  guardianRole: string;
  guardianPhoneNumber: string;
  guardianEmail: string;
  teamMemberName: OptionType;
  teamMemberDiscipline: string;
  teamMemberRole: string;
  teamMemberStartDate: string;
  teamMemberEndDate: string;
  teamMemberPhoneNumber: string;
  teamMemberEmail: string;
  otherTeamMemberName: string;
  otherTeamMemberStartDate: string;
  otherTeamMemberEndDate: string;
};

export interface UnifiedMemberType {
  id: string | null;
  uiUuid?: string | null;
  name: string | null;
  role?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  discipline?: string | null;
  jobDescription?: string | null;
  parentId?: string | null;
  othersId?: string | null;
  teamMemberId?: string | null;
  memberType: MemberType;
}

const initialFormikValues: MemberFormType = {
  memberType: 'guardian',
  guardianName: { id: '', label: '' },
  guardianRole: '',
  guardianEmail: '',
  guardianPhoneNumber: '',
  teamMemberName: { id: '', label: '' },
  teamMemberDiscipline: '',
  teamMemberRole: '',
  teamMemberStartDate: '',
  teamMemberEndDate: '',
  teamMemberEmail: '',
  teamMemberPhoneNumber: '',
  otherTeamMemberName: '',
  otherTeamMemberStartDate: '',
  otherTeamMemberEndDate: '',
};

interface TableData {
  name: string;
  role: string;
  discipline: string;
  email: string;
  phoneNumber: string;
  jobDescription: string;
  startDate: string;
  endDate: string;
  actions: string;
}

export const IfspRadioData = [
  {
    value: 'guardian',
    labelId: 'IFSP.GuardianText',
    defaultLabel: 'Guardian',
  },
  {
    value: 'team',
    labelId: 'IFSP.TeamMemberText',
    defaultLabel: 'Team Member',
  },
  {
    value: 'other',
    labelId: 'IFSP.OtherText',
    defaultLabel: 'Others',
  },
];

export const initialDefaultRoutine = [
  {
    id: '',
    name: 'wakingUp',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'mealTime',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'napTime',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'playTime',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'downTime',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'bathTime',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'bedTime',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'familyActivities',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'socialGatherings',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'comingFromHome',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'dropOff',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'runningErrands',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'workSchedule',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'childCare',
    value: '',
    comment: '',
  },
  {
    id: '',
    name: 'doctorAppointment',
    value: '',
    comment: '',
  },
];

const headCells: HeadCell<TableData>[] = [
  {
    id: 'name',
    labelId: 'IFSP.Name',
    defaultLabelId: 'Name',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'discipline',
    labelId: 'IFSP.DisciplineText',
    defaultLabelId: 'Discipline',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'role',
    labelId: 'IFSP.RoleText',
    defaultLabelId: 'Role',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'email',
    labelId: 'IFSP.EmailText',
    defaultLabelId: 'Email',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'phoneNumber',
    labelId: 'IFSP.PhoneNumberText',
    defaultLabelId: 'Phone Number',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'startDate',
    labelId: 'IFSP.StartDateText',
    defaultLabelId: 'Start Date',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'endDate',
    labelId: 'IFSP.EndDateText',
    defaultLabelId: 'End Date',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'actions',
    labelId: 'IFSP.ActionsText',
    defaultLabelId: 'Actions',
    numeric: false,
    requiredSorting: false,
  },
];

const validationSchema = yup.object({
  memberType: yup.string().nullable(),
  guardianEmail: yup.string().nullable(),
  guardianPhoneNumber: yup.string().nullable(),
  teamMemberEmail: yup.string().nullable(),
  teamMemberPhoneNumber: yup.string().nullable(),

  guardianName: yup
    .object({
      id: yup.string().nullable(),
      label: yup.string().nullable(),
    })
    .when('memberType', {
      is: 'guardian',
      then: (schema) =>
        schema.shape({
          id: yup.string().required('guardianName.fieldEmptyMessage'),
          label: yup.string().required('guardianName.fieldEmptyMessage'),
        }),
    }),
  guardianRole: yup.string().nullable(),
  teamMemberName: yup
    .object({
      id: yup.string().nullable(),
      label: yup.string().nullable(),
    })
    .when('memberType', {
      is: 'team',
      then: (schema) =>
        schema.shape({
          id: yup.string().required('teamMemberName.fieldEmptyMessage'),
          label: yup.string().required('teamMemberName.fieldEmptyMessage'),
        }),
    }),

  teamMemberDiscipline: yup.string().when('memberType', {
    is: 'team',
    then: (s) => s.required('teamMemberDiscipline.fieldEmptyMessage'),
    otherwise: (s) => s.nullable(),
  }),

  teamMemberRole: yup.string().when('memberType', {
    is: 'team',
    then: (s) => s.required('teamMemberRole.fieldEmptyMessage'),
    otherwise: (s) => s.nullable(),
  }),

  teamMemberStartDate: yup.string().when('memberType', {
    is: 'team',
    then: (s) => s.required('teamMemberStartDate.fieldEmptyMessage'),
    otherwise: (s) => s.nullable(),
  }),

  otherTeamMemberName: yup.string().when('memberType', {
    is: 'other',
    then: (s) => s.required('otherTeam.fieldEmptyMessage'),
    otherwise: (s) => s.nullable(),
  }),

  otherTeamMemberStartDate: yup.string().when('memberType', {
    is: 'other',
    then: (s) => s.required('otherTeamMemberStartDate.fieldEmptyMessage'),
    otherwise: (s) => s.nullable(),
  }),
});

const validateDate = (values: MemberFormType) => {
  const errors: Partial<{
    teamMemberStartDate: string | null;
    teamMemberEndDate: string | null;
    otherTeamMemberStartDate: string | null;
    otherTeamMemberEndDate: string | null;
  }> = {};

  if (values.teamMemberStartDate && values.teamMemberEndDate) {
    const startDate = dayjs(values.teamMemberStartDate, 'MM/DD/YYYY');
    const endDate = dayjs(values.teamMemberEndDate, 'MM/DD/YYYY');

    if (startDate.isAfter(endDate)) {
      errors.teamMemberEndDate = 'IFSP.endDateValidationError';
    }
  }
  if (datePickerMinDateMaxDateValidate(values.teamMemberStartDate)) {
    errors.teamMemberStartDate = 'datePickerMinDateMaxDateValidate';
  }

  if (datePickerMinDateMaxDateValidate(values.teamMemberEndDate)) {
    errors.teamMemberEndDate = 'datePickerMinDateMaxDateValidate';
  }

  if (values.otherTeamMemberStartDate && values.otherTeamMemberEndDate) {
    const startDate = dayjs(values.otherTeamMemberStartDate, 'MM/DD/YYYY');
    const endDate = dayjs(values.otherTeamMemberEndDate, 'MM/DD/YYYY');
    if (startDate.isAfter(endDate)) {
      errors.otherTeamMemberEndDate = 'IFSP.endDateValidationError';
    }
  }
  if (datePickerMinDateMaxDateValidate(values.otherTeamMemberStartDate)) {
    errors.otherTeamMemberStartDate = 'datePickerMinDateMaxDateValidate';
  }

  if (datePickerMinDateMaxDateValidate(values.otherTeamMemberEndDate)) {
    errors.otherTeamMemberEndDate = 'datePickerMinDateMaxDateValidate';
  }
  return errors;
};

const IfspMainScreen = () => {
  const [employeeList, setEmployeeList] = useState<EmployeeListType[]>([
    {
      id: '',
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      disciplineType: '',
      disciplineHistoryList: [],
      phone: '',
      roles: [],
    },
  ]);
  const [parentContactes, setParentContactes] = useState<OptionType[]>([]);
  const [teamMembersDiscipline, setTeamMembersDiscipline] = useState<
    OptionType[]
  >([]);
  const [teamMembersRole, setTeamMembersRole] = useState<OptionType[]>([]);
  const [ifspTeamTable, setIfspTeamTable] = useState<UnifiedMemberType[]>([]);
  const [editMemberId, setEditMemberId] = useState<string | null>(null);
  const [deleteMemberId, setDeleteMemberId] = useState<{
    fnId: string | null;
    id: string | null;
  }>({ fnId: null, id: null });
  const [deleteWarning, setDeleteWarning] = useState<boolean>(false);
  const [showAlertDialog, setShowAlertDialog] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [toastrVariable, setToastrVariable] = useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = useState('');
  const [isInitialLoading, setIsInitialLoading] = useState<boolean>(true);
  const [toastrId, setToastrId] = useState('');
  const [primarySettingCode, setPrimarySettingCode] = useState<OptionType[]>(
    [],
  );
  const [isEditModeActivated, setIsEditModeActivated] =
    useState<boolean>(false);
  const [openUnSavedModal, setOpenUnSavedModal] = useState<boolean>(false);
  const [openRadioSwitchModal, setOpenRadioSwitchModal] =
    useState<boolean>(false);
  const [pendingMemberType, setPendingMemberType] = useState<string>('');
  const [transitionRenderKey, setTransitionRenderKey] = useState(0);
  const [openScreenLeavingUnSavedModal, setOpenScreenLeavingUnSavedModal] =
    useState<boolean>(false);
  const ifspClientDetails = useAppSelector(
    (state) => state.ifspClientDetails.ifspClientDetails,
  );
  const ifspOutcomesBannerData = useAppSelector(
    (state) => state.ifspOutComes.displayBanner,
  );
  const ifspSDPAndConsentBannerData = useAppSelector(
    (state) => state.ifspSDPAndConsent.sdpAndConsent.displayBanner,
  );
  const ifspTransitionBannerData = useAppSelector(
    (state) => state.ifspTransitionDetails.ifspTransitionData.displayBanner,
  );
  const originalIfspClientDetails = useAppSelector(
    (state) => state.ifspClientDetails.originalIfspClientDetails,
  );

  const ifspPermission = useAppSelector((state) => state.ifspPermissionDetails);
  const ifspToTBRPrerequisites = useAppSelector(
    (state) => state.ifspTBRPreRequisite,
  );

  const ifspUnsavedFields = useAppSelector((state) => state.ifspUnsavedFields);

  const [isIfspInitiated, setIsIfspInitiated] = useState<boolean>(false);
  const [ifspInitiateAlert, setIfspInitiateAlert] = useState<boolean>(false);
  const [reasonData, setReasonData] = useState<OptionType[]>([]);
  const [activeReasonData, setActiveReasonData] = useState<OptionType[]>([]);
  const [isSaveClicked, setIsSaveClicked] = useState<boolean>(false);
  const [infoModal, setInfoModal] = useState(false);
  const [openTBRCheckModal, setOpenTBRCheckModal] = useState<boolean>(false);
  const [shareModal, setShareModal] = useState<boolean>(false);
  const [openDownloadLanguageModal, setOpenDownloadLanguageModal] =
    useState<boolean>(false);
  const [selectedLang, setSelectedLang] = useState<string>('en');
  const dispatch = useAppDispatch();
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const { lookups } = useContext(LookUpContext);
  const { isCommonAreaChanged } = useIfspUnsavedChanges();
  const parentRef = useRef<HTMLDivElement>(null);
  const { hasUnsavedChanges, handleUpdateUnsavedChanges } = useContext(
    UnSavedChangesContext,
  );

  const validationsError =
    useIfspClientInfoValidationCheckToSubmit(ifspClientDetails);
  const { lookupsDemographics, updateDemographics } = useContext(LookUpContext);
  const formikRef = useRef<FormikProps<MemberFormType>>(null);
  const autoScrollRef = React.useRef<HTMLDivElement>(null);
  const navigation = useNavigate();
  const { state } = useLocation();

  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
    'backend.update_ifsp_after_lock',
    'backend.upload_ifsp_to_tbr',
    'backend.ifsp_admin_amendments',
  ]);

  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';

  const newIfspTranslationId = useRef('NEWIFSP');

  useEffect(() => {
    if (lookups) {
      setPrimarySettingCode(() => {
        return lookups.primarySettingCode.map((item) => {
          return { id: item.code, label: item.description };
        });
      });
      setReasonData(() => {
        return lookups.reason.map((item) => {
          return { id: item.code, label: item.description };
        });
      });

      setActiveReasonData(() => {
        return lookups.reason
          .filter(
            (item) =>
              item.active || item.code === ifspClientDetails.reasonForDelay,
          )
          .map((item) => {
            return { id: item.code, label: item.description };
          });
      });
    }
  }, [lookups, ifspClientDetails.reasonForDelay]);

  useEffect(() => {
    const guardianMembers = ifspClientDetails.guardianTeamMember.map((g) => ({
      ...g,
      id: g.id,
      parentId: g.parentId,
      name: g.name,
      role: g.role,
      email: g.email,
      phoneNumber: g.phoneNumber,
      memberType: 'guardian' as const,
    }));

    const team = ifspClientDetails.teamMember.map((t) => ({
      ...t,
      id: t.id,
      teamMemberId: t.teamMemberId,
      name: t.name,
      role: t.role,
      email: t.email,
      phoneNumber: t.phoneNumber,
      startDate: t.startDate,
      endDate: t.endDate,
      discipline: t.discipline,
      memberType: 'team' as const,
    }));

    const other = ifspClientDetails.otherTeamMember.map((o) => ({
      ...o,
      id: o.id,
      othersId: o.othersId,
      name: o.name,
      jobDescription: o.jobDescription,
      startDate: o.startDate,
      endDate: o.endDate,
      memberType: 'other' as const,
    }));

    setIfspTeamTable([...guardianMembers, ...team, ...other]);
  }, [
    ifspClientDetails.guardianTeamMember,
    ifspClientDetails.teamMember,
    ifspClientDetails.otherTeamMember,
  ]);

  useEffect(() => {
    const clientId = localStorage.getItem('ClientId');
    toggleLoader(true);
    getIfsp(clientId as string)
      .then((data) => {
        const teamMemberIds = data.teamMember
          .filter((x) => x.role && x.teamMemberId)
          .map((x) => x.teamMemberId as string);
        fetchEmployees('', 0, teamMemberIds);
        const formattedData: IfspClientDetailsType = {
          ...data,
          teamMember: data.teamMember.map((t) => ({
            ...t,
            uiUuid: t.uiUuid ?? uuidv4(),
          })),
          otherTeamMember: data.otherTeamMember.map((o) => ({
            ...o,
            uiUuid: o.uiUuid ?? uuidv4(),
          })),
          guardianTeamMember: data.guardianTeamMember.map((g) => ({
            ...g,
            uiUuid: g.uiUuid ?? uuidv4(),
          })),
        };
        dispatch(setIfspClientDetails(formattedData));
        if (data.ifspId) {
          setIsIfspInitiated(true);
        } else {
          setIsIfspInitiated(false);
        }
      })
      .catch((error) => {
        setOpen(true);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrVariable('error');
          setToastrId('IFSP.failedToGet');
          setToastrDefaultMessage('Failed to get IFSP data');
        }
      })
      .finally(() => {
        setIsInitialLoading(false);
        dispatch(
          updateIfspPermission({
            hasClientEditPermission:
              referralStatus === 'Inactive'
                ? permissions['backend.clients'].canEdit &&
                  permissions['backend.in_active_referrals'].canEdit
                : permissions['backend.clients'].canEdit,
            hasIfspEditPermissionAfterLock:
              permissions['backend.update_ifsp_after_lock'].canEdit,
            hasIfspDeletePermissionAfterLock:
              permissions['backend.update_ifsp_after_lock'].canDelete,
            hasUploadToTBRPermission:
              permissions['backend.upload_ifsp_to_tbr'].canEdit,
            hasAdminAmendmentAddPermission:
              permissions['backend.ifsp_admin_amendments'].canAdd,
            hasAdminAmendmentEditPermission:
              permissions['backend.ifsp_admin_amendments'].canEdit,
            hasAdminAmendmentDeletePermission:
              permissions['backend.ifsp_admin_amendments'].canDelete,
          }),
        );
      });
  }, []);

  useEffect(() => {
    if (
      dayjs(ifspClientDetails.ifspDueDate, 'MM/DD/YYYY').isAfter(
        dayjs(ifspClientDetails.ifspFirstMeetingDate, 'MM/DD/YYYY'),
      ) ||
      dayjs(ifspClientDetails.ifspDueDate, 'MM/DD/YYYY').isSame(
        dayjs(ifspClientDetails.ifspFirstMeetingDate, 'MM/DD/YYYY'),
      )
    ) {
      dispatch(
        updateIfspClientDetails({
          reasonForDelay: null,
        }),
      );
    }
  }, [ifspClientDetails.ifspFirstMeetingDate]);

  useEffect(() => {
    if (state?.openTransitionPlanning) {
      autoScrollRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [state?.openTransitionPlanning]);

  useEffect(() => {
    setParentContactes(() => {
      const formattedContacts: OptionType[] = ifspClientDetails.guardians
        .filter(
          (contact) =>
            !ifspClientDetails.guardianTeamMember.some(
              (parent) => parent.parentId?.toString() === contact.id.toString(),
            ),
        )
        .map((filteredContact) => {
          const prefixes = [
            filteredContact.isPrimary && 'Primary',
            filteredContact.isLegal && 'Legal',
          ].filter(Boolean);

          return {
            id: filteredContact.id,
            label: `${filteredContact.name} ${
              filteredContact.isGuardian && prefixes.length > 0
                ? ` - (${prefixes.join(', ')})`
                : ''
            }`,
          };
        });

      return formattedContacts;
    });
  }, [ifspClientDetails.guardians, ifspClientDetails.guardianTeamMember]);

  useEffect(() => {
    dispatch(
      updateIfspPermission({
        hasClientEditPermission:
          referralStatus === 'Inactive'
            ? permissions['backend.clients'].canEdit &&
              permissions['backend.in_active_referrals'].canEdit &&
              !isOtherLanguage()
            : permissions['backend.clients'].canEdit && !isOtherLanguage(),
        hasIfspEditPermissionAfterLock:
          permissions['backend.update_ifsp_after_lock'].canEdit &&
          !isOtherLanguage(),
        hasIfspDeletePermissionAfterLock:
          permissions['backend.update_ifsp_after_lock'].canDelete &&
          !isOtherLanguage(),
        hasUploadToTBRPermission:
          permissions['backend.upload_ifsp_to_tbr'].canEdit &&
          !isOtherLanguage(),
        hasAdminAmendmentAddPermission:
          permissions['backend.ifsp_admin_amendments'].canAdd &&
          !isOtherLanguage(),
        hasAdminAmendmentEditPermission:
          permissions['backend.ifsp_admin_amendments'].canEdit &&
          !isOtherLanguage(),
        hasAdminAmendmentDeletePermission:
          permissions['backend.ifsp_admin_amendments'].canDelete &&
          !isOtherLanguage(),
      }),
    );
  }, [selectedLang]);

  const hasAnyValue = (values?: MemberFormType) => {
    if (!values) return false;

    return Object.entries(values)
      .filter(
        ([key]) =>
          ![
            'memberType',
            'guardianRole',
            'guardianEmail',
            'guardianPhoneNumber',
            'teamMemberEmail',
            'teamMemberPhoneNumber',
          ].includes(key),
      )
      .some(([, value]) => {
        if (typeof value === 'object' && value !== null) {
          return Object.values(value).some(Boolean);
        }

        return Boolean(value);
      });
  };

  const ifspUnsavedFieldsRef = useRef(ifspUnsavedFields);

  useEffect(() => {
    ifspUnsavedFieldsRef.current = ifspUnsavedFields;
  }, [ifspUnsavedFields]);

  const UnsavedChangesWatcher = () => {
    const { values } = useFormikContext<MemberFormType>();

    useEffect(() => {
      const hasChanges = hasAnyValue(values);
      const current = ifspUnsavedFieldsRef.current;

      if (current.isAnyTeamMemberFieldsChanged === hasChanges) {
        return;
      }

      dispatch(
        updateIfspUnsavedFields({
          ...current,
          isAnyTeamMemberFieldsChanged: hasChanges,
        }),
      );
    }, [values]);

    return null;
  };

  const sanitizeSearch = (text: string) => {
    if (!text) return '';

    if (text.includes(',')) {
      const [last, first] = text.split(',');
      return `${first?.trim()} ${last?.trim()}`;
    }

    return text;
  };

  const fetchEmployees = (
    search: string,
    page: number,
    teamMemberId: string[] = [],
  ): Promise<OptionType[]> => {
    if (editMemberId) return Promise.resolve([]);
    const cleanSearch = sanitizeSearch(search);
    const teamMemberIds =
      teamMemberId.length > 0
        ? teamMemberId
        : ifspClientDetails.teamMember
            .filter((x) => x.role && x.teamMemberId)
            .map((x) => x.teamMemberId!)
            .filter(Boolean);

    return getAllEmployeeByName(
      cleanSearch,
      page,
      10,
      page === 0 ? teamMemberIds : [],
    )
      .then((data) => {
        setEmployeeList((prev) => (page === 0 ? data : [...prev, ...data]));

        toggleLoader(false);

        return data.map((emp) => ({
          id: emp.id,
          label: `${emp.lastName}, ${emp.firstName}`,
        }));
      })
      .catch((error) => {
        toggleLoader(false);
        setOpen(true);
        setToastrVariable('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
          return [];
        } else {
          setToastrId('IFSP.failedToGetEmployeeData');
          setToastrDefaultMessage('Failed to get employee data');
          return [];
        }
      });
  };

  const handleAddNewContact = (values: MemberFormType) => {
    const filteredGuardian = ifspClientDetails.guardians.find(
      (g) => g.id === values.guardianName.id,
    );
    if (!filteredGuardian) {
      return;
    }
    dispatch(
      updateIfspClientDetails({
        ...ifspClientDetails,
        guardianTeamMember: [
          ...ifspClientDetails.guardianTeamMember,
          {
            id: '',
            parentId: filteredGuardian.id,
            uiUuid: uuidv4(),
            name: filteredGuardian.name,
            email: values.guardianEmail,
            phoneNumber: values.guardianPhoneNumber,
            role: values.guardianRole,
            memberType: values.memberType,
          },
        ],
      }),
    );

    formikRef.current?.resetForm({
      values: {
        ...initialFormikValues,
        memberType: formikRef.current.values.memberType,
      },
    });
  };

  const handleAddNewTeamMemberContact = (values: MemberFormType) => {
    const membersToCheck =
      isEditModeActivated && editMemberId
        ? ifspClientDetails.teamMember.filter((m) => m.uiUuid !== editMemberId)
        : ifspClientDetails.teamMember;

    const isTememberDuplicatedOrOverlapping = membersToCheck.some((prev) => {
      const isOverlapping =
        (dayjs(prev.startDate).isBefore(dayjs(values.teamMemberEndDate)) &&
          dayjs(prev.endDate).isAfter(dayjs(values.teamMemberStartDate))) ||
        dayjs(prev.startDate).isSame(
          dayjs(values.teamMemberStartDate),
          'day',
        ) ||
        dayjs(prev.endDate).isSame(dayjs(values.teamMemberEndDate), 'day');

      return (
        prev.email === values.teamMemberEmail &&
        (prev.role === values.teamMemberRole ||
          prev.discipline === values.teamMemberDiscipline) &&
        isOverlapping
      );
    });

    if (isTememberDuplicatedOrOverlapping) {
      setShowAlertDialog(true);
      return;
    }

    if (isEditModeActivated) {
      dispatch(
        updateIfspClientDetails({
          ...ifspClientDetails,
          teamMember: ifspClientDetails.teamMember.map((member) => {
            if (member.uiUuid === editMemberId) {
              return {
                ...member,
                teamMemberId: values.teamMemberName.id,
                startDate: values.teamMemberStartDate,
                endDate: values.teamMemberEndDate,
                discipline: values.teamMemberDiscipline,
                email: values.teamMemberEmail,
                name: values.teamMemberName.label,
                phoneNumber: values.teamMemberPhoneNumber,
                role: values.teamMemberRole,
              };
            }
            return member;
          }),
        }),
      );
    } else {
      dispatch(
        updateIfspClientDetails({
          ...ifspClientDetails,
          teamMember: [
            ...ifspClientDetails.teamMember,
            {
              id: '',
              teamMemberId: values.teamMemberName.id,
              uiUuid: uuidv4(),
              startDate: values.teamMemberStartDate,
              endDate: values.teamMemberEndDate,
              discipline: values.teamMemberDiscipline,
              email: values.teamMemberEmail,
              name: values.teamMemberName.label,
              phoneNumber: values.teamMemberPhoneNumber,
              role: values.teamMemberRole,
              memberType: values.memberType,
            },
          ],
        }),
      );
    }
    formikRef.current?.resetForm({
      values: {
        ...initialFormikValues,
        memberType: formikRef.current.values.memberType,
      },
    });
    setIsEditModeActivated(false);
    setEditMemberId('');
    setTeamMembersDiscipline([]);
    setTeamMembersRole([]);
  };

  const handelAddOtherContact = (values: MemberFormType) => {
    if (isEditModeActivated) {
      dispatch(
        updateIfspClientDetails({
          ...ifspClientDetails,
          otherTeamMember: ifspClientDetails.otherTeamMember.map((member) => {
            if (member.uiUuid === editMemberId) {
              return {
                ...member,
                startDate: values.otherTeamMemberStartDate,
                endDate: values.otherTeamMemberEndDate,
                name: values.otherTeamMemberName,
              };
            }
            return member;
          }),
        }),
      );
    } else {
      dispatch(
        updateIfspClientDetails({
          ...ifspClientDetails,
          otherTeamMember: [
            ...ifspClientDetails.otherTeamMember,
            {
              id: '',
              othersId: uuidv4(),
              uiUuid: uuidv4(),
              startDate: values.otherTeamMemberStartDate,
              endDate: values.otherTeamMemberEndDate,
              name: values.otherTeamMemberName,
              memberType: values.memberType,
              jobDescription: '',
            },
          ],
        }),
      );
    }
    formikRef.current?.resetForm({
      values: {
        ...initialFormikValues,
        memberType: formikRef.current.values.memberType,
      },
    });
  };

  const handleEditMemberData = (editableData: UnifiedMemberType) => {
    if (editableData.memberType === 'team') {
      setTeamMembersRole(() => {
        const filteredContactsRoles: OptionType[] = employeeList
          .filter((contact) => contact.id === editableData?.teamMemberId)
          .flatMap((contact) =>
            contact.roles
              ? contact.roles.flatMap((roleString) =>
                  roleString.split(',').map((roleId) => ({
                    id: roleId.trim() || '',
                    label:
                      employeeRoles.find(
                        (empRole) => empRole.id === roleId.trim(),
                      )?.label ?? '',
                  })),
                )
              : [],
          );
        return filteredContactsRoles;
      });

      setTeamMembersDiscipline(() => {
        const disciplines = employeeList
          .filter((contact) => contact.id === editableData?.teamMemberId)
          .flatMap(
            (contact) =>
              contact.disciplineHistoryList?.map((history) => ({
                id:
                  lookups?.employeeDiscipline?.find(
                    (discipline) => discipline.code === history.disciplineType,
                  )?.code || '',
                label:
                  lookups?.employeeDiscipline?.find(
                    (discipline) => discipline.code === history.disciplineType,
                  )?.description || '',
              })) || [],
          );

        return Array.from(new Map(disciplines.map((d) => [d.id, d])).values());
      });
      formikRef.current?.resetForm({
        values: {
          ...initialFormikValues,
          memberType: editableData.memberType,
          teamMemberStartDate: editableData.startDate ?? '',
          teamMemberEndDate: editableData.endDate ?? '',
          teamMemberDiscipline: editableData.discipline ?? '',
          teamMemberEmail: editableData.email ?? '',
          teamMemberPhoneNumber: editableData.phoneNumber ?? '',
          teamMemberRole: editableData.role ?? '',
          teamMemberName: {
            id: editableData.teamMemberId ?? '',
            label: editableData.name ?? '',
          },
        },
      });
    }
    if (editableData.memberType === 'other') {
      formikRef.current?.resetForm({
        values: {
          ...initialFormikValues,
          memberType: editableData.memberType,
          otherTeamMemberStartDate: editableData.startDate ?? '',
          otherTeamMemberEndDate: editableData.endDate ?? '',
          otherTeamMemberName: editableData.name ?? '',
        },
      });
    }
    setEditMemberId(editableData.uiUuid ?? '');
  };

  const getDeleteMemberDetails = (memberDetails: UnifiedMemberType) => {
    setDeleteMemberId({
      fnId: memberDetails.uiUuid ?? null,
      id: memberDetails.id ?? null,
    });
    setDeleteWarning(true);
  };

  const handleDeleteTeamMember = () => {
    toggleLoader(true);
    if (deleteMemberId?.id) {
      deleteIfspMembers(deleteMemberId?.id ?? '')
        .then(() => {
          dispatch(
            updateIfspClientDetails({
              otherTeamMember: ifspClientDetails.otherTeamMember.filter(
                (data) => data.id !== deleteMemberId.id,
              ),
              teamMember: ifspClientDetails.teamMember.filter(
                (data) => data.id !== deleteMemberId.id,
              ),
              guardianTeamMember: ifspClientDetails.guardianTeamMember.filter(
                (data) => data.id !== deleteMemberId.id,
              ),
            }),
          );
          setOpen(true);
          setToastrVariable('success');
          setToastrId('IFSP.ClientDetails.DeleteSuccess');
          setToastrDefaultMessage('IFSP member deleted successfully');
        })
        .catch(() => {
          setOpen(true);
          setToastrVariable('error');
          setToastrId('IFSP.ClientDetails.DeleteError');
          setToastrDefaultMessage('Failed to delete IFSP member');
        })
        .finally(() => {
          toggleLoader(false);
          setDeleteWarning(false);
        });
    } else if (deleteMemberId.fnId) {
      dispatch(
        updateIfspClientDetails({
          otherTeamMember: ifspClientDetails.otherTeamMember.filter(
            (data) => data.uiUuid !== deleteMemberId.fnId,
          ),
          teamMember: ifspClientDetails.teamMember.filter(
            (data) => data.uiUuid !== deleteMemberId.fnId,
          ),
          guardianTeamMember: ifspClientDetails.guardianTeamMember.filter(
            (data) => data.uiUuid !== deleteMemberId.fnId,
          ),
        }),
      );
      setDeleteWarning(false);
      toggleLoader(false);
    }
  };

  const handleInitiateIfsp = () => {
    const clientId = localStorage.getItem('ClientId');
    toggleLoader(true);
    initiateIfsp(clientId ?? '')
      .then(() => {
        setIfspInitiateAlert(false);
        setIsIfspInitiated(true);
        setOpen(true);
        setToastrVariable('success');
        setToastrId('IFSP.ClientDetails.InitiateSuccess');
        setToastrDefaultMessage('IFSP initiated successfully');
        return handleGetIfspDetails();
      })
      .catch(() => {
        setOpen(true);
        setToastrVariable('error');
        setToastrId('IFSP.ClientDetails.InitiateError');
        setToastrDefaultMessage('Failed to initiate IFSP');
      })
      .finally(() => {
        toggleLoader(false);
      });
  };

  const handleGetIfspDetails = () => {
    const clientId = localStorage.getItem('ClientId');
    return getIfsp(clientId ?? '')
      .then((data) => {
        const formattedData: IfspClientDetailsType = {
          ...data,
          teamMember: data.teamMember.map((t) => ({
            ...t,
            uiUuid: t.uiUuid ?? uuidv4(),
          })),
          otherTeamMember: data.otherTeamMember.map((o) => ({
            ...o,
            uiUuid: o.uiUuid ?? uuidv4(),
          })),
          guardianTeamMember: data.guardianTeamMember.map((g) => ({
            ...g,
            uiUuid: g.uiUuid ?? uuidv4(),
          })),
        };
        toggleLoader(false);
        dispatch(setIfspClientDetails(formattedData));
      })
      .catch((error) => {
        toggleLoader(false);
        setOpen(true);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrVariable('error');
          setToastrId('IFSP.ClientDetails.GetError');
          setToastrDefaultMessage('Failed to get IFSP data');
        }
      });
  };

  const handleAddOrUpdateIfspDetails = () => {
    if (Object.keys(validationsError).length > 0) {
      setIsSaveClicked(true);
      setOpen(true);
      setToastrVariable('error');
      setToastrId('IFSP.ClientDetails.UpdateError');
      setToastrDefaultMessage(
        'Please correct the highlighted fields before submitting.',
      );
      setTimeout(() => {
        setOpen(false);
      }, 3000);
      return;
    } else {
      setIsSaveClicked(false);
    }

    toggleLoader(true);
    if (ifspClientDetails.ifspId) {
      updateIfsp(ifspClientDetails)
        .then(() => {
          setOpen(true);
          setToastrVariable('success');
          setToastrId('IFSP.ClientDetails.UpdateSuccess');
          setToastrDefaultMessage('IFSP updated successfully');
          return handleGetIfspDetails();
        })
        .catch((error) => {
          setOpen(true);
          setToastrVariable('error');
          const apiError = error as ApiMessage;
          if (
            apiError.code === 1163 ||
            apiError.code === 1170 ||
            apiError.code === 1175
          ) {
            setToastrId(apiError.message);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId('IFSP.ClientDetails.UpdateError');
            setToastrDefaultMessage('Failed to update IFSP');
          }
        })
        .finally(() => {
          toggleLoader(false);
        });
    } else {
      createMainIfsp(ifspClientDetails)
        .then(() => {
          setOpen(true);
          setToastrVariable('success');
          setToastrId('IFSP.ClientDetails.CreateSuccess');
          setToastrDefaultMessage('IFSP created successfully');
          return handleGetIfspDetails();
        })
        .catch(() => {
          setOpen(true);
          setToastrVariable('error');
          setToastrId('IFSP.ClientDetails.CreateError');
          setToastrDefaultMessage('Failed to create IFSP');
        })
        .finally(() => {
          toggleLoader(false);
        });
    }
  };

  const handleGetTBRPreRequisite = () => {
    toggleLoader(true);
    return getTBRPreRequisite()
      .then((res) => {
        dispatch(
          setTBRPreRequisite({
            isCommonAreaChecked:
              res.tbrIfspId > 0
                ? res.commonAreaReadyToUpload
                : res.isCommonAreaChecked,
            isOutcomeChecked: res.isOutcomeChecked,
            isServiceDeliveryChecked: res.isServiceDeliveryChecked,
            isTransitionChecked: res.isTransitionChecked,
            tbrIfspId: res.tbrIfspId,
            ifspId: res.ifspId,
            outcomeReadyToUpload: res.outcomeReadyToUpload,
            commonAreaReadyToUpload: res.commonAreaReadyToUpload,
            serviceDeliveryReadyToUpload: res.serviceDeliveryReadyToUpload,
            transitionReadyToUpload: res.transitionReadyToUpload,
            isAlreadyCommonAreaChecked: res.isCommonAreaChecked,
            isAlreadyOutcomeChecked: res.isOutcomeChecked,
            isAlreadyServiceDeliveryChecked: res.isServiceDeliveryChecked,
            isAlreadyTransitionChecked: res.isTransitionChecked,
            pendingUploadEvaluationToTbr: res.pendingUploadEvaluationToTbr,
          }),
        );
        setOpenTBRCheckModal(true);
      })
      .catch((error) => {
        setOpen(true);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrVariable('error');
          setToastrId('IFSP.ClientDetails.GetError');
          setToastrDefaultMessage('Failed to get IFSP data');
        }
      })
      .finally(() => {
        toggleLoader(false);
      });
  };

  const getTbrFlagDetails = () => {
    const clientId = localStorage.getItem('ClientId');
    getIfsp(clientId as string)
      .then((data) => {
        dispatch(
          updateIfspClientDetails({
            ...ifspClientDetails,
            tbrUpdateRequired: data.tbrUpdateRequired,
            outcomeTbrUpdateRequired: data.outcomeTbrUpdateRequired,
            serviceDeliveryTbrUpdateRequired:
              data.serviceDeliveryTbrUpdateRequired,
            transitionTbrUpdateRequired: data.transitionTbrUpdateRequired,
            isCommonAreaChecked: data.isCommonAreaChecked,
            isOutcomeChecked: data.isOutcomeChecked,
            isServiceDeliveryChecked: data.isServiceDeliveryChecked,
            isTransitionChecked: data.isTransitionChecked,
          }),
          dispatch(
            updateOriginalIfspClientDetails({
              ...ifspClientDetails,
              tbrUpdateRequired: data.tbrUpdateRequired,
              outcomeTbrUpdateRequired: data.outcomeTbrUpdateRequired,
              serviceDeliveryTbrUpdateRequired:
                data.serviceDeliveryTbrUpdateRequired,
              transitionTbrUpdateRequired: data.transitionTbrUpdateRequired,
              isCommonAreaChecked: data.isCommonAreaChecked,
              isOutcomeChecked: data.isOutcomeChecked,
              isServiceDeliveryChecked: data.isServiceDeliveryChecked,
              isTransitionChecked: data.isTransitionChecked,
            }),
          ),
        );
      })
      .catch((error) => {
        toggleLoader(false);
        setOpen(true);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrVariable('error');
          setToastrId('IFSP.ClientDetails.GetError');
          setToastrDefaultMessage('Failed to get IFSP data');
        }
      });
  };

  const handleUploadToTBR = () => {
    toggleLoader(true);
    uploadIfspToTBR({
      isCommonAreaChecked: ifspToTBRPrerequisites.isCommonAreaChecked,
      isOutcomeChecked: ifspToTBRPrerequisites.isOutcomeChecked,
      isServiceDeliveryChecked: ifspToTBRPrerequisites.isServiceDeliveryChecked,
      isTransitionChecked: ifspToTBRPrerequisites.isTransitionChecked,
    })
      .then(() => {
        getTbrFlagDetails();
        toggleLoader(false);
        setOpen(true);
        setToastrVariable('success');
        setToastrId('IFSP.ClientDetails.SubmitSuccess');
        setToastrDefaultMessage('Data submitted successfully');
        setOpenTBRCheckModal(false);
      })
      .catch(() => {
        toggleLoader(false);
        setOpen(true);
        setToastrVariable('error');
        setToastrId('IFSP.ClientDetails.SubmitError');
        setToastrDefaultMessage('Failed to submit data');
      });
  };

  const handleDownload = (language: string) => {
    const clientIdToDownload = localStorage.getItem('ClientId');
    toggleLoader(true);
    const localTimezone = dayjs.tz.guess();
    if (clientIdToDownload) {
      downloadMainIfsp(clientIdToDownload, localTimezone, language)
        .then((response) => {
          const blob = new Blob([response], { type: 'application/pdf' });

          // Create a Blob URL
          const blobUrl = URL.createObjectURL(blob);

          // Open the Blob URL in a new tab
          const anchor = document.createElement('a');
          anchor.href = blobUrl;
          anchor.target = '_blank';
          anchor.download = getClientDocumentFileName(
            `Individualized Family Service Plan (IFSP).pdf`,
          ); // Set desired file name here

          // Append anchor to document body
          document.body.appendChild(anchor);

          // Trigger anchor click
          anchor.click();

          window.open(blobUrl, '_blank');

          // Clean up after use
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(anchor);

          toggleLoader(false);
        })
        .catch((error) => {
          toggleLoader(false);
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId('ConsentForms.downloadErrorMsg');
            setToastrDefaultMessage('Failed to download');
          }
        });
    }
  };

  const handleOpenInfoModal = () => {
    setInfoModal(true);
  };

  const handleCloseInfoModal = () => {
    setInfoModal(false);
  };

  const handleCloseSnakBar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  if (isInitialLoading) {
    return null;
  }
  return (
    <Box component="main">
      <TranslateWidget
        initialLanguage={selectedLang}
        screenId={newIfspTranslationId.current}
        languageChangeCallback={(language) => {
          setSelectedLang(language);
        }}
      >
        <SnackBarComponent
          open={open}
          handleClose={handleCloseSnakBar}
          successOrError={toastrVariable}
          labelId={toastrId}
          defaultMessageId={toastrDefaultMessage}
        />
        {shareModal && (
          <ShareDownloadModal
            modalVisible={shareModal}
            closeModal={() => setShareModal(false)}
            screenName="NEW_IFSP"
          />
        )}
        <LanguageSelectionDialog
          open={openDownloadLanguageModal}
          onClose={() => setOpenDownloadLanguageModal(false)}
          onConfirm={(language) => {
            setOpenDownloadLanguageModal(false);
            handleDownload(language);
          }}
        />
        <ModalPopup
          open={showAlertDialog}
          description="duplicateWarningMessage"
          onOk={() => {
            setShowAlertDialog(false);
          }}
          labelId2="Clientpage.Okbtn"
          positiveActionLabel="Ok"
        />

        <InformationModal
          open={infoModal}
          titleLabel="Information"
          titleDefaultLabel="Information"
          buttonLabel="IFSP.InfoOkButton"
          buttonDefaultLabel="Ok"
          onClose={() => handleCloseInfoModal()}
          infoLabelId="IFSP.ClientDetails.Info"
          infoDefaultLabel={info}
        />
        <ModalPopup
          open={ifspInitiateAlert}
          description="ifspInitiateAlertMessage"
          onOk={() => {
            handleInitiateIfsp();
          }}
          onCancel={() => {
            setIfspInitiateAlert(false);
          }}
          labelId1="Clientpage.cancelbtn"
          negativeActionLabel="cancelText"
          labelId2="Clientpage.Okbtn"
          positiveActionLabel="Ok"
        />
        <ModalPopup
          open={deleteWarning}
          description="permanentDeleteConfirmationMessage"
          onOk={() => {
            handleDeleteTeamMember();
          }}
          onCancel={() => {
            setDeleteWarning(false);
          }}
          labelId1="Clientpage.cancelbtn"
          negativeActionLabel="cancelText"
          labelId2="Clientpage.Okbtn"
          positiveActionLabel="Ok"
        />
        <ModalPopup
          open={openScreenLeavingUnSavedModal}
          description="UnsavedAlertDescriptionWhileLeaving"
          onCancel={() => {
            setOpenScreenLeavingUnSavedModal(false);
          }}
          onOk={() => {
            if (!isIfspInitiated || ifspClientDetails.ifspId) {
              setOpenScreenLeavingUnSavedModal(false);
              handleUpdateUnsavedChanges(false);
              if (state?.from === 'IFSPReview') {
                navigation(IFSP_REVIEW_ROUTE_NAME);
              } else {
                navigation(FACESHEET);
              }
            } else {
              handleUpdateUnsavedChanges(false);
              dispatch(setIfspClientDetails(originalIfspClientDetails));
              setOpenScreenLeavingUnSavedModal(false);
              setIsIfspInitiated(false);
            }
          }}
          labelId1="UnSavedAlertCancel"
          labelId2="UnSavedAlertLeave"
          negativeActionLabel="No"
          positiveActionLabel="Yes"
        />
        <ModalPopup
          open={openRadioSwitchModal}
          onCancel={() => {
            setOpenRadioSwitchModal(false);
          }}
          onOk={() => {
            formikRef.current?.setTouched({}, false);
            formikRef.current?.resetForm({
              values: {
                ...initialFormikValues,
                memberType: formikRef.current.values.memberType,
              },
            });
            setOpenRadioSwitchModal(false);
            setEditMemberId('');
            setIsEditModeActivated(false);
            setEditMemberId('');
            setDeleteWarning(false);
            formikRef.current?.setFieldValue('memberType', pendingMemberType);
          }}
          description="UnsavedAlertDescriptionWhileSwitching"
          labelId1="UnSavedAlertCancel"
          labelId2="UnsavedAlertSwitch"
          negativeActionLabel="No"
          positiveActionLabel="Yes"
        />
        <ModalPopup
          open={openUnSavedModal}
          description="formUnsavedChangesMessage"
          onCancel={() => {
            setOpenUnSavedModal(false);
          }}
          onOk={() => {
            dispatch(setIfspClientDetails(originalIfspClientDetails));
            formikRef.current?.resetForm({
              values: initialFormikValues,
            });
            setTransitionRenderKey((prev) => prev + 1);
            setTimeout(() => {
              setOpenUnSavedModal(false);
            }, 500);
          }}
          labelId1="Clientpage.cancelbtn"
          negativeActionLabel="Cancel"
          labelId2="Clientpage.Okbtn"
          positiveActionLabel="Ok"
        />

        <IfspTBRCheckModal
          open={openTBRCheckModal}
          onClose={() => {
            setOpenTBRCheckModal(false);
          }}
          onSave={() => handleUploadToTBR()}
        />

        <Box component="section">
          {(ifspClientDetails.displayBanner ||
            ifspOutcomesBannerData ||
            ifspSDPAndConsentBannerData ||
            ifspTransitionBannerData) && (
            <Box
              component="div"
              className="flex__ alignItemCenter justifyContent-Center width__100"
            >
              <Box
                className="flex__ alignItemCenter justifyContent-Center"
                sx={{
                  backgroundColor: '#00C6B8',
                  position: 'absolute',
                  top: 115,
                  width: '50%',
                  padding: '5px 0px 5px 0px',
                  borderRadius: '40px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '90%',
                  }}
                >
                  <MediumTypography
                    labelid="IFSP.MainScreen.PartiallyUploadedToTbr"
                    defaultlabel="The IFSP is not fully synchronized with TBR. Click “Upload to TBR” to sync the latest data between TC and TBR."
                    fontweight={600}
                    textColor="#ffffff"
                  />
                </Box>
              </Box>
            </Box>
          )}
          <Box component="div" className="rowContainer">
            <Grid container>
              <Grid item xs={6} lg={6}>
                <Box className="flex__  align__items__center">
                  <CustomBackArrow
                    onClick={() => {
                      if (hasUnsavedChanges) {
                        setOpenScreenLeavingUnSavedModal(true);
                      } else if (!isIfspInitiated || ifspClientDetails.ifspId) {
                        handleUpdateUnsavedChanges(false);

                        if (state?.from === 'IFSPReview') {
                          localStorage.removeItem('Demographics');
                          localStorage.removeItem('clientName');
                          localStorage.removeItem('clientReferralDetails');
                          localStorage.removeItem(REFERRAL_STATUS_KEY);
                          localStorage.removeItem(REFERRAL_PROGRAM_KEY);

                          if (lookupsDemographics) {
                            updateDemographics({
                              ...lookupsDemographics,
                              firstName: '',
                              middleName: '',
                              lastName: '',
                              suffix: '',
                              ageInMonths: null,
                              sex: null,
                              dateOfBirth: '',
                              dphId: null,
                            });
                          }

                          navigation(IFSP_REVIEW_ROUTE_NAME);
                        } else {
                          navigation(FACESHEET);
                        }
                      } else {
                        setIsIfspInitiated(false);
                      }
                    }}
                  />
                  <TitleText
                    labelid="ifsp.Title"
                    defaultlabel="Individualized Family Service Plan (IFSP)"
                    className="ml-md"
                  />
                </Box>
              </Grid>
              {isIfspInitiated && (
                <Grid
                  item
                  xs={6}
                  lg={6}
                  className="flex__ align__items__center justifyContent-FlexEnd"
                >
                  <Box component="div" className="flex__">
                    <ButtonComponent
                      className="btn-primary btn-submit mr-xs"
                      labelId="IFSP.MainScreen.UploadToTbr"
                      defaultLabelId={
                        ifspPermission.hasUploadToTBRPermission
                          ? 'Upload to TBR'
                          : 'Review'
                      }
                      variantType="contained"
                      onClick={() => {
                        handleGetTBRPreRequisite();
                      }}
                      disabled={!ifspClientDetails.ifspId}
                    />
                    <ButtonComponent
                      className="btn-primary btn-submit"
                      labelId="ConsentForms.listActionDownloadToolTipLabel"
                      defaultLabelId="Download"
                      variantType="contained"
                      onClick={() => setOpenDownloadLanguageModal(true)}
                    />
                    <ButtonComponent
                      className="btn-primary btn-submit ml-xs"
                      labelId="ConsentForms.listActionShareToolTipLabel"
                      defaultLabelId="Share"
                      variantType="contained"
                      onClick={() => setShareModal(true)}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
          {isIfspInitiated && (
            <Card
              className="formCardview mb-md"
              sx={{
                marginTop:
                  ifspClientDetails.displayBanner ||
                  ifspOutcomesBannerData ||
                  ifspSDPAndConsentBannerData ||
                  ifspTransitionBannerData
                    ? '16px'
                    : 'unset',
              }}
            >
              <Box
                ref={parentRef}
                key={transitionRenderKey}
                style={{
                  pointerEvents: !ifspPermission.hasClientEditPermission
                    ? 'none'
                    : 'auto',
                  opacity: !ifspPermission.hasClientEditPermission
                    ? '0.5'
                    : '1 ',
                }}
                onKeyDownCapture={(e) => {
                  if (!ifspPermission.hasClientEditPermission) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
                onFocus={() => {
                  if (!ifspPermission.hasClientEditPermission) {
                    if (parentRef.current) parentRef.current.focus();
                  }
                }}
              >
                <Box
                  component="div"
                  className="flex__  mb-md alignItemCenter justifyContentSpaceBtw"
                >
                  <Box className="flex__ alignItemCenter">
                    <DPHLogo style={{ width: '110px', height: '110px' }} />
                    <MediumTypography
                      labelid="ifsp.FormTitle"
                      defaultlabel="Massachusetts Department of Public Health Individualized Family Service Plan"
                      className="ml-md"
                      fontweight={600}
                      fontSize="20px"
                    />
                  </Box>
                  <InfoIcon
                    onClick={handleOpenInfoModal}
                    className="cursorPointer"
                  />
                </Box>
                <SingleLine className="width__100" />
                <Box component="div" className="mt-sm mb-sm ">
                  <ProgramPanel
                    program={{
                      ...ifspClientDetails.program,
                      faxNumber: ifspClientDetails.program.fax,
                    }}
                  />
                </Box>
                <SingleLine className="width__100" />
                <Box component="div" className="flex__ mt-sm mb-sm ">
                  <Box component="div" className="flex__ ">
                    <MediumTypography
                      labelid="ifsp.ClientName"
                      defaultlabel="Client Name:"
                      textColor="#97A6A5"
                      fontSize="16px"
                    />

                    <Tooltip
                      className="minWidthContent"
                      title={
                        ifspClientDetails.client.name &&
                        ifspClientDetails.client.name.length > 10
                          ? `${ifspClientDetails.client.name}`
                          : ''
                      }
                      followCursor
                      arrow={true}
                    >
                      <Box component="div" className="width150px ">
                        <MediumTypography
                          fontSize="16px"
                          sxProps={{
                            paddingLeft:
                              ifspClientDetails.client.name === '' ||
                              ifspClientDetails.client.name === null
                                ? '24px'
                                : '6px',
                            color: '#2A4241',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                          }}
                          label={
                            ifspClientDetails.client.name === '' ||
                            ifspClientDetails.client.name === null
                              ? '-'
                              : `${ifspClientDetails.client.name}`
                          }
                        />
                      </Box>
                    </Tooltip>
                  </Box>
                  <Box component="div" className="flex__">
                    <MediumTypography
                      className="ml-sm"
                      labelid="ifsp.Sex"
                      defaultlabel="Sex:"
                      textColor="#97A6A5"
                      fontSize="16px"
                    />
                    <MediumTypography
                      fontSize="16px"
                      textColor="#2A4241"
                      className="pr-lg"
                      sxProps={{
                        paddingLeft:
                          ifspClientDetails.client.sex === '' ||
                          ifspClientDetails.client.sex === null
                            ? '24px'
                            : '6px',
                      }}
                      label={
                        ifspClientDetails.client.sex === '' ||
                        ifspClientDetails.client.sex === null
                          ? '-'
                          : convertGenderToFrontend(
                              ifspClientDetails.client.sex,
                            )
                      }
                    />
                  </Box>
                  <Box component="div" className="flex__">
                    <MediumTypography
                      labelid="ifsp.DPHID"
                      defaultlabel="DPH ID:"
                      textColor="#97A6A5"
                      fontSize="16px"
                    />
                    <MediumTypography
                      fontSize="16px"
                      textColor="#2A4241"
                      className="pl-xs pr-lg"
                      label={
                        ifspClientDetails.client.enrollmentNumber === '' ||
                        ifspClientDetails.client.enrollmentNumber === null
                          ? '-'
                          : ifspClientDetails.client.enrollmentNumber
                      }
                    />
                  </Box>
                  <Box component="div" className="flex__">
                    <MediumTypography
                      labelid="ifsp.DateofBirth"
                      defaultlabel="Date of Birth:"
                      textColor="#97A6A5"
                      fontSize="16px"
                    />
                    <MediumTypography
                      fontSize="16px"
                      textColor="#2A4241"
                      className="pl-xs pr-lg"
                      label={
                        ifspClientDetails.client.dateOfBirth === '' ||
                        ifspClientDetails.client.dateOfBirth === null
                          ? '-'
                          : ifspClientDetails.client.dateOfBirth
                      }
                    />
                  </Box>
                  <Box component="div" className="flex__ visibility__hidden">
                    <MediumTypography
                      labelid="ifsp.Status"
                      defaultlabel="Status:"
                      textColor="#97A6A5"
                      fontSize="16px"
                    />
                    <MediumTypography
                      fontSize="16px"
                      textColor="#2A4241"
                      className="pl-xs pr-lg"
                      label={'jo'}
                    />
                  </Box>
                </Box>
                <SingleLine
                  className="width__100"
                  backgroundColor={
                    ifspClientDetails.tbrUpdateRequired &&
                    !ifspClientDetails.isCommonAreaChecked
                      ? '#F96300'
                      : '#CFDEDE'
                  }
                />
                <Grid container className="mt-md mb-md">
                  <Grid
                    container
                    rowSpacing={'24px'}
                    columnSpacing={'44px'}
                    className="pt-md"
                  >
                    <Grid item xs={5}>
                      <DatePickerComponent
                        key={ifspClientDetails.ifspFirstMeetingDate}
                        className="bg__white"
                        labelid={'IFSP.FirstMeetingDate'}
                        defaultlabelid={'IFSP First Meeting Date'}
                        disableFuture={true}
                        value={
                          ifspClientDetails.ifspFirstMeetingDate
                            ? dayjs(ifspClientDetails.ifspFirstMeetingDate)
                            : null
                        }
                        handlechange={(dateValue: Dayjs | null) => {
                          if (dateValue) {
                            const formattedDate =
                              dayjs(dateValue).format('MM/DD/YYYY');
                            dispatch(
                              updateIfspClientDetails({
                                ...ifspClientDetails,
                                ifspFirstMeetingDate: formattedDate,
                              }),
                            );
                          } else {
                            dispatch(
                              updateIfspClientDetails({
                                ...ifspClientDetails,
                                ifspFirstMeetingDate: null,
                              }),
                            );
                          }
                        }}
                        required
                        maxDate={dayjs()}
                        disabledDate={
                          ifspClientDetails.isConsentSignedAtLeastOnce &&
                          !ifspPermission.hasIfspEditPermissionAfterLock
                        }
                      />
                      {isSaveClicked &&
                        validationsError.ifspFirstMeetingDate && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={
                              validationsError.ifspFirstMeetingDateErrorMessageId
                            }
                            defaultlabel={
                              validationsError.ifspFirstMeetingDateErrorMessage
                            }
                          />
                        )}
                    </Grid>
                    <Grid item xs={5}>
                      <DatePickerComponent
                        key={ifspClientDetails.ifspSignedDate}
                        className="bg__white"
                        labelid={'IFSP.SignedDate'}
                        defaultlabelid={'IFSP Signed Date'}
                        disableFuture={false}
                        value={
                          ifspClientDetails.ifspSignedDate
                            ? dayjs(ifspClientDetails.ifspSignedDate)
                            : null
                        }
                        handlechange={(dateValue: Dayjs | null) => {
                          if (dateValue) {
                            const formattedDate =
                              dayjs(dateValue).format('MM/DD/YYYY');
                            dispatch(
                              updateIfspClientDetails({
                                ...ifspClientDetails,
                                ifspSignedDate: formattedDate,
                              }),
                            );
                          } else {
                            dispatch(
                              updateIfspClientDetails({
                                ...ifspClientDetails,
                                ifspSignedDate: null,
                              }),
                            );
                          }
                        }}
                        minDate={dayjs(ifspClientDetails.ifspFirstMeetingDate)}
                        required={!!ifspClientDetails.tbrIfspId}
                        disabledDate={
                          !!ifspClientDetails.tbrIfspId &&
                          ifspClientDetails.isConsentSignedAtLeastOnce &&
                          !ifspPermission.hasIfspEditPermissionAfterLock
                        }
                      />
                      {isSaveClicked && validationsError.ifspSignedDate && (
                        <MediumTypography
                          className="errorText-md"
                          labelid={
                            validationsError.ifspSignedDateErrorMessageId
                          }
                          defaultlabel={
                            validationsError.ifspSignedDateErrorMessage
                          }
                        />
                      )}
                    </Grid>
                    <Grid item xs={5}>
                      <DropdownComponent
                        names={primarySettingCode}
                        labelid="IFSP.PrimarySettingCode"
                        defaultlabelid="Primary Settings Code"
                        value={
                          ifspClientDetails.primarySettingCode
                            ? ifspClientDetails.primarySettingCode
                            : ''
                        }
                        handleChange={(value) => {
                          dispatch(
                            updateIfspClientDetails({
                              ...ifspClientDetails,
                              primarySettingCode: value,
                              justification: '',
                            }),
                          );
                        }}
                        disabled={!ifspPermission.hasClientEditPermission}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <DatePickerComponent
                        className="bg__white"
                        labelid={'IFSP.ReviewSignedDate'}
                        defaultlabelid={'IFSP Review Signed Date'}
                        value={
                          ifspClientDetails.ifspReviewSignedDate
                            ? dayjs(ifspClientDetails.ifspReviewSignedDate)
                            : null
                        }
                        handlechange={() => {}}
                        disabledDate={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {ifspClientDetails.primarySettingCode !== 'HOME' &&
                  ifspClientDetails.primarySettingCode !== 'COMMUNITY' &&
                  ifspClientDetails.primarySettingCode && (
                    <Box sx={{ width: '70%', marginY: '24px' }}>
                      <CommentTextbox
                        Value={ifspClientDetails.justification}
                        placeholder="Justification"
                        name="justification"
                        maxLength={500}
                        handlechange={(e) => {
                          dispatch(
                            updateIfspClientDetails({
                              ...ifspClientDetails,
                              justification: e,
                            }),
                          );
                        }}
                        Required
                        rows={2}
                        className={
                          ifspClientDetails.primarySettingCode === 'HOME' ||
                          ifspClientDetails.primarySettingCode === 'COMMUNITY'
                            ? 'cursor__disabled'
                            : ''
                        }
                        disabled={
                          ifspClientDetails.primarySettingCode === 'HOME' ||
                          ifspClientDetails.primarySettingCode === 'COMMUNITY'
                        }
                      />
                      {isSaveClicked && validationsError.justification && (
                        <MediumTypography
                          className="errorText-md"
                          labelid={validationsError.justificationErrorMessageId}
                          defaultlabel={
                            validationsError.justificationErrorMessage
                          }
                        />
                      )}
                    </Box>
                  )}
                <Box sx={{ borderTop: '1px solid #CFDEDE' }} className="mt-md">
                  <Grid container columnSpacing={'44px'}>
                    <Grid item xs={5}>
                      <MediumTypography
                        labelid="NEWIFSP.ReasonForLateIFSPMeeting"
                        defaultlabel="Reason for late IFSP Meeting"
                        fontSize="18px"
                        fontweight={600}
                        textColor="#2A4241"
                        className="pb-md pt-md"
                      />
                      <AutocompleteSearch
                        labelId={'IFSP.SelecttheReasonforDelay'}
                        defaultId={'Select the reason for delay'}
                        selectedValue={{
                          id: ifspClientDetails.reasonForDelay || '',
                          label:
                            reasonData.find(
                              (reason) =>
                                reason.id === ifspClientDetails.reasonForDelay,
                            )?.label || '',
                        }}
                        data={activeReasonData}
                        onSelectItem={(value: OptionType | null) => {
                          if (value) {
                            dispatch(
                              updateIfspClientDetails({
                                ...ifspClientDetails,
                                reasonForDelay: value.id,
                              }),
                            );
                          } else {
                            dispatch(
                              updateIfspClientDetails({
                                ...ifspClientDetails,
                                reasonForDelay: '',
                              }),
                            );
                          }
                        }}
                        disableLabel={false}
                        disabled={
                          dayjs(
                            ifspClientDetails.ifspDueDate,
                            'MM/DD/YYYY',
                          ).isAfter(
                            dayjs(
                              ifspClientDetails.ifspFirstMeetingDate,
                              'MM/DD/YYYY',
                            ),
                          ) ||
                          dayjs(
                            ifspClientDetails.ifspDueDate,
                            'MM/DD/YYYY',
                          ).isSame(
                            dayjs(
                              ifspClientDetails.ifspFirstMeetingDate,
                              'MM/DD/YYYY',
                            ),
                          ) ||
                          (!!originalIfspClientDetails.reasonForDelay &&
                            ifspClientDetails.isConsentSignedAtLeastOnce &&
                            !ifspPermission.hasIfspEditPermissionAfterLock)
                        }
                      />
                      {isSaveClicked && validationsError.reasonForDelay && (
                        <MediumTypography
                          className="errorText-md"
                          labelid={
                            validationsError.reasonForDelayErrorMessageId
                          }
                          defaultlabel={
                            validationsError.reasonForDelayErrorMessage
                          }
                        />
                      )}
                    </Grid>
                  </Grid>

                  {ifspClientDetails.tbrUpdateRequired &&
                    !ifspClientDetails.isCommonAreaChecked && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          width: '100%',
                        }}
                      >
                        <Tooltip
                          title="Please note that changes have been made to one or more of the following fields, which may not be fully synchronized with TBR: IFSP First Meeting Date, IFSP Signed Date, Primary Setting Code, and Reason for Late IFSP Meeting."
                          followCursor
                          arrow
                          className="cursor__pointer"
                        >
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              width: 'fit-content',
                            }}
                          >
                            <WaningInfoIcon />
                            <MediumTypography
                              labelid="ifsp.clientpagetbrupdate.warning"
                              defaultlabel="Data is not fully synchronized with TBR"
                              textColor="#F96300"
                              textstyle="end"
                              className="pl-xs"
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                    )}
                </Box>
                {ifspClientDetails.reviewHistory.length > 0 && (
                  <Box
                    component="div"
                    className="mt-md"
                    sx={{
                      borderTop:
                        ifspClientDetails.tbrUpdateRequired &&
                        !ifspClientDetails.isCommonAreaChecked
                          ? '1px solid #F96300'
                          : '1px solid #CFDEDE',
                    }}
                  >
                    <MediumTypography
                      labelid="ifsp.reviewedon"
                      defaultlabel="Reviewed on"
                      fontSize="18px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pb-md pt-md"
                    />
                    <Box className="flex__ flex__wrap" sx={{ rowGap: '8px' }}>
                      {ifspClientDetails.reviewHistory
                        .filter((date) => date.date)
                        .map((date) => (
                          <Box
                            key={date.id}
                            className="flex__ align__items__center mr-sm"
                            sx={{
                              backgroundColor: '#E7F0F0',
                              padding: '5px',
                              borderRadius: '4px',
                            }}
                          >
                            <MediumTypography
                              label={
                                date.date?.toString().split(' ')[0] as string
                              }
                              fontSize="14px"
                              fontweight={400}
                              textColor="#2A4241"
                              sxProps={{ paddingRight: '5px' }}
                            />
                            <File />
                          </Box>
                        ))}
                    </Box>
                  </Box>
                )}
                <Box
                  component="div"
                  className="mt-md"
                  sx={{
                    borderTop:
                      ifspClientDetails.tbrUpdateRequired &&
                      !ifspClientDetails.isCommonAreaChecked &&
                      ifspClientDetails.reviewHistory.length === 0
                        ? '1px solid #F96300'
                        : '1px solid #CFDEDE',
                  }}
                >
                  <MediumTypography
                    labelid="ifsp.MembersTitle"
                    defaultlabel="IFSP Team Members: (including family members, caregivers, EI providers, SSP and others)"
                    fontSize="18px"
                    fontweight={600}
                    textColor="#2A4241"
                    className="pb-md pt-md"
                  />
                </Box>
                <Box component="div">
                  <Formik
                    initialValues={initialFormikValues}
                    validate={validateDate}
                    innerRef={formikRef}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                      if (values.memberType === 'guardian') {
                        handleAddNewContact(values);
                      } else if (values.memberType === 'team') {
                        handleAddNewTeamMemberContact(values);
                      } else {
                        handelAddOtherContact(values);
                      }
                    }}
                  >
                    {({
                      values,
                      setFieldValue,
                      setTouched,
                      errors,
                      touched,
                      handleSubmit,
                    }) => (
                      <Box component="div">
                        <UnsavedChangesWatcher />
                        <CustomRadioButton
                          data={IfspRadioData}
                          value={values.memberType}
                          onSelectItem={(value) => {
                            if (
                              ifspUnsavedFields.isAnyTeamMemberFieldsChanged &&
                              value
                            ) {
                              setPendingMemberType(value);
                              setOpenRadioSwitchModal(true);
                            } else if (value) {
                              setTouched({}, false);
                              formikRef.current?.resetForm({
                                values: {
                                  ...initialFormikValues,
                                  memberType:
                                    formikRef.current.values.memberType,
                                },
                              });
                              setEditMemberId('');
                              setIsEditModeActivated(false);
                              setEditMemberId('');
                              setDeleteWarning(false);
                              setFieldValue('memberType', value);
                            }
                          }}
                          disable={isOtherLanguage()}
                        />
                        {values.memberType === 'guardian' && (
                          <Box component="div">
                            <Grid
                              container
                              direction={'row'}
                              className="mt-md mb-lg"
                            >
                              <Grid item xs={5}>
                                <AutocompleteSearch
                                  key={values.guardianName.id}
                                  data={parentContactes}
                                  labelId="IFSP.selectName"
                                  defaultId="Select Name"
                                  Required={true}
                                  selectedValue={values.guardianName}
                                  onSelectItem={(e) => {
                                    if (e) {
                                      const contact =
                                        ifspClientDetails.guardians.find(
                                          (x) => x.id === e.id,
                                        );
                                      setFieldValue('guardianName', e);
                                      setFieldValue(
                                        'guardianEmail',
                                        contact?.email,
                                      );
                                      setFieldValue(
                                        'guardianRole',
                                        contact?.relationshipToClient,
                                      );
                                      setFieldValue(
                                        'guardianPhoneNumber',
                                        contact?.phone,
                                      );
                                    } else {
                                      setFieldValue('guardianName', {
                                        id: '',
                                        label: '',
                                      });
                                      setFieldValue('guardianEmail', '');
                                      setFieldValue('guardianPhoneNumber', '');
                                    }
                                  }}
                                  disableLabel={false}
                                  disabled={isOtherLanguage()}
                                />
                                {errors.guardianName?.id &&
                                  touched.guardianName?.id && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.guardianName.id}
                                      defaultlabel="Guardian is required"
                                    />
                                  )}
                              </Grid>
                              {isOtherLanguage() ? null : (
                                <Grid
                                  item
                                  xs={1}
                                  className="cursorPointer align__items__center flex__justify__center"
                                  onClick={() => {
                                    handleSubmit();
                                  }}
                                >
                                  <Box
                                    component="div"
                                    className="flex__ mt-xs "
                                  >
                                    <AddNew className="ml-sm" />
                                    <MediumTypography
                                      labelid="IFSP.Add"
                                      defaultlabel="Add"
                                      className="pl-sm"
                                    />
                                  </Box>
                                </Grid>
                              )}
                            </Grid>
                          </Box>
                        )}
                        {values.memberType === 'team' && (
                          <Box component="div" className="mt-md mb-md">
                            <Grid container columnSpacing={'32px'}>
                              <Grid item xs={5}>
                                <LazyAutocompleteSearch
                                  labelId="IFSP.selectName"
                                  defaultId="Select Name"
                                  value={
                                    values.teamMemberName
                                      ? values.teamMemberName
                                      : { id: '', label: '' }
                                  }
                                  onChange={(e) => {
                                    if (e) {
                                      setTeamMembersRole(() => {
                                        const filteredContactsRoles: OptionType[] =
                                          employeeList
                                            .filter(
                                              (contact) => contact.id === e.id,
                                            )
                                            .flatMap((contact) =>
                                              contact.roles
                                                ? contact.roles.flatMap(
                                                    (roleString) =>
                                                      roleString
                                                        .split(',')
                                                        .map((roleId) => ({
                                                          id: roleId.trim(),
                                                          label:
                                                            employeeRoles.find(
                                                              (empRole) =>
                                                                empRole.id ===
                                                                roleId.trim(),
                                                            )?.label ?? '',
                                                        })),
                                                  )
                                                : [],
                                            );
                                        return filteredContactsRoles;
                                      });

                                      setTeamMembersDiscipline(() => {
                                        const disciplines = employeeList
                                          .filter(
                                            (contact) => contact.id === e.id,
                                          )
                                          .flatMap(
                                            (contact) =>
                                              contact.disciplineHistoryList?.map(
                                                (history) => ({
                                                  id: history.disciplineType,
                                                  label:
                                                    lookups?.employeeDiscipline.find(
                                                      (dis) =>
                                                        dis.code ===
                                                        history.disciplineType,
                                                    )?.description || '',
                                                }),
                                              ) || [],
                                          );

                                        return Array.from(
                                          new Map(
                                            disciplines.map((d) => [d.id, d]),
                                          ).values(),
                                        );
                                      });

                                      const emp = employeeList.find(
                                        (empDetail) => empDetail.id === e.id,
                                      );
                                      setFieldValue(
                                        'teamMemberEmail',
                                        emp?.email,
                                      );
                                      setFieldValue(
                                        'teamMemberPhoneNumber',
                                        emp?.phone,
                                      );
                                      setFieldValue('teamMemberName', e);
                                    } else {
                                      setFieldValue('teamMemberName', {
                                        id: '',
                                        label: '',
                                      });
                                      setTeamMembersRole([]);
                                      setTeamMembersDiscipline([]);
                                    }
                                  }}
                                  fetchOptions={fetchEmployees}
                                  required
                                  disabled={
                                    isOtherLanguage() || isEditModeActivated
                                  }
                                />
                                {errors.teamMemberName?.id &&
                                  touched.teamMemberName?.id && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.teamMemberName.id}
                                      defaultlabel="Team Member Name is required"
                                    />
                                  )}
                              </Grid>

                              <Grid item xs={5} className="mb-md">
                                <DropdownComponent
                                  names={teamMembersDiscipline}
                                  labelid="Ifsp.discipline"
                                  defaultlabelid="Select Discipline"
                                  value={
                                    values.teamMemberDiscipline
                                      ? values.teamMemberDiscipline
                                      : ''
                                  }
                                  handleChange={(e) => {
                                    setFieldValue('teamMemberDiscipline', e);
                                  }}
                                  Required
                                  disabled={isOtherLanguage()}
                                />
                                {errors.teamMemberDiscipline &&
                                  touched.teamMemberDiscipline && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.teamMemberDiscipline}
                                      defaultlabel="Discipline is required"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={5} className="mb-md">
                                <DropdownComponent
                                  names={teamMembersRole}
                                  labelid="Ifsp.selectRole"
                                  defaultlabelid="Select Role"
                                  value={
                                    values.teamMemberRole
                                      ? values.teamMemberRole
                                      : ''
                                  }
                                  handleChange={(e) => {
                                    setFieldValue('teamMemberRole', e);
                                  }}
                                  Required
                                  disabled={isOtherLanguage()}
                                />
                                {errors.teamMemberRole &&
                                  touched.teamMemberRole && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.teamMemberRole}
                                      defaultlabel="Role is required"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={5}>
                                <DatePickerComponent
                                  labelid={'IFSP.startDate'}
                                  defaultlabelid={'Start Date*'}
                                  required={true}
                                  disableFuture={false}
                                  value={
                                    values.teamMemberStartDate === ''
                                      ? null
                                      : dayjs(values.teamMemberStartDate)
                                  }
                                  handlechange={(dateValue: Dayjs | null) => {
                                    if (dateValue) {
                                      const formattedDate =
                                        dayjs(dateValue).format('MM/DD/YYYY');

                                      setFieldValue(
                                        'teamMemberStartDate',
                                        formattedDate,
                                      );
                                    } else {
                                      setFieldValue(
                                        'teamMemberStartDate',
                                        null,
                                      );
                                    }
                                  }}
                                  disabledDate={isOtherLanguage()}
                                />
                                {errors.teamMemberStartDate &&
                                  touched.teamMemberEndDate && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.teamMemberStartDate}
                                      defaultlabel="Start date is required"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={5}>
                                <DatePickerComponent
                                  labelid={'IFSP.teamMembersEndDate'}
                                  defaultlabelid={'End Date'}
                                  disableFuture={false}
                                  value={
                                    values.teamMemberEndDate === ''
                                      ? null
                                      : dayjs(values.teamMemberEndDate)
                                  }
                                  handlechange={(dateValue: Dayjs | null) => {
                                    if (dateValue) {
                                      const formattedDate =
                                        dayjs(dateValue).format('MM/DD/YYYY');

                                      setFieldValue(
                                        'teamMemberEndDate',
                                        formattedDate,
                                      );
                                    } else {
                                      setFieldValue('teamMemberEndDate', null);
                                    }
                                  }}
                                  disabledDate={isOtherLanguage()}
                                />
                                {errors.teamMemberEndDate &&
                                  touched.teamMemberEndDate && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.teamMemberEndDate}
                                    />
                                  )}
                              </Grid>
                              {isOtherLanguage() ? null : (
                                <Grid
                                  container
                                  xs={1}
                                  className="cursorPointer "
                                  onClick={() => {
                                    handleSubmit();
                                  }}
                                >
                                  <Grid item>
                                    <Box
                                      component="div"
                                      className="flex__ pt-xs "
                                    >
                                      <AddNew className="ml-sm mr-sm" />
                                      <MediumTypography
                                        labelid={
                                          isEditModeActivated
                                            ? 'IFSP.Update'
                                            : 'IFSP.Add'
                                        }
                                        defaultlabel={
                                          isEditModeActivated ? 'Update' : 'Add'
                                        }
                                      />
                                    </Box>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Box>
                        )}
                        {values.memberType === 'other' && (
                          <Box component="div" className="mt-md mb-md">
                            <Grid container columnSpacing={'32px'}>
                              <Grid item xs={5} className="mb-md">
                                <Textinput
                                  labelid="IFSP.Name"
                                  defaultlabelid="Name"
                                  Value={values.otherTeamMemberName}
                                  inputProps={{
                                    className: 'translate',
                                    maxLength: 40,
                                  }}
                                  handlechange={(e) => {
                                    setFieldValue('otherTeamMemberName', e);
                                  }}
                                  Required
                                />
                                {errors.otherTeamMemberName &&
                                  touched.otherTeamMemberName && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.otherTeamMemberName}
                                      defaultlabel="Name is required"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={5}>
                                <DatePickerComponent
                                  labelid={'IFSP.startDate'}
                                  defaultlabelid={'Start Date*'}
                                  required={true}
                                  disableFuture={false}
                                  value={
                                    values.otherTeamMemberStartDate === ''
                                      ? null
                                      : dayjs(values.otherTeamMemberStartDate)
                                  }
                                  handlechange={(dateValue: Dayjs | null) => {
                                    if (dateValue) {
                                      const formattedDate =
                                        dayjs(dateValue).format('MM/DD/YYYY');

                                      setFieldValue(
                                        'otherTeamMemberStartDate',
                                        formattedDate,
                                      );
                                    } else {
                                      setFieldValue(
                                        'otherTeamMemberStartDate',
                                        null,
                                      );
                                    }
                                  }}
                                  disabledDate={isOtherLanguage()}
                                />
                                {errors.otherTeamMemberStartDate &&
                                  touched.otherTeamMemberStartDate && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.otherTeamMemberStartDate}
                                      defaultlabel="Start date is required"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={5}>
                                <DatePickerComponent
                                  labelid={'IFSP.teamMembersEndDate'}
                                  defaultlabelid={'End Date'}
                                  disableFuture={false}
                                  value={
                                    values.otherTeamMemberEndDate === ''
                                      ? null
                                      : dayjs(values.otherTeamMemberEndDate)
                                  }
                                  handlechange={(dateValue: Dayjs | null) => {
                                    if (dateValue) {
                                      const formattedDate =
                                        dayjs(dateValue).format('MM/DD/YYYY');
                                      setFieldValue(
                                        'otherTeamMemberEndDate',
                                        formattedDate,
                                      );
                                    } else {
                                      setFieldValue(
                                        'otherTeamMemberEndDate',
                                        null,
                                      );
                                    }
                                  }}
                                  disabledDate={isOtherLanguage()}
                                />
                                {errors.otherTeamMemberEndDate &&
                                  touched.otherTeamMemberEndDate && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.otherTeamMemberEndDate}
                                      defaultlabel="End date is required"
                                    />
                                  )}
                              </Grid>
                              {isOtherLanguage() ? null : (
                                <Grid
                                  container
                                  xs={1}
                                  className="cursorPointer "
                                  onClick={() => {
                                    handleSubmit();
                                  }}
                                >
                                  <Grid item>
                                    <Box
                                      component="div"
                                      className="flex__ pt-xs "
                                    >
                                      <AddNew className="ml-sm mr-sm" />
                                      <MediumTypography
                                        labelid={
                                          isEditModeActivated
                                            ? 'IFSP.Update'
                                            : 'IFSP.Add'
                                        }
                                        defaultlabel={
                                          isEditModeActivated ? 'Update' : 'Add'
                                        }
                                      />
                                    </Box>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Formik>
                </Box>
                <Box component="div" className="respoScrollTable mt-lg mb-md">
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHeader
                        className="listDataTableHead"
                        headerNames={headCells}
                        checkBoxRequired={false}
                      />
                      <TableBody className="tableRowcss">
                        {ifspTeamTable.map((listData) => (
                          <IfspMembersTableRow
                            isIfspScreenLocked={isOtherLanguage()}
                            key={listData.uiUuid}
                            data={listData}
                            onDelete={() => getDeleteMemberDetails(listData)}
                            onEdit={(data: UnifiedMemberType) => {
                              setIsEditModeActivated(true);
                              setEditMemberId(data.uiUuid ?? '');
                              handleEditMemberData(data);
                            }}
                          />
                        ))}
                      </TableBody>
                    </Table>
                    {ifspTeamTable.length === 0 && (
                      <Box component="div" className="width__100">
                        <MediumTypography
                          textstyle={'center'}
                          labelid="IFSP.emptyMessage"
                          defaultlabel="No data added yet"
                          className="p-sm"
                        />
                      </Box>
                    )}
                  </TableContainer>
                </Box>
                <Box
                  component="div"
                  className="flex__ justifyContent-FlexEnd mt-lg"
                >
                  <ButtonComponent
                    className="btn-primary btn-cancel mr-md"
                    labelId={'cancelText'}
                    defaultLabelId="Cancel"
                    variantType="outlined"
                    onClick={() => {
                      if (
                        isCommonAreaChanged ||
                        ifspUnsavedFields.isAnyTeamMemberFieldsChanged
                      ) {
                        setOpenUnSavedModal(true);
                      } else {
                        setOpenUnSavedModal(false);
                      }
                    }}
                  />
                  <ButtonComponent
                    className="btn-primary btn-submit"
                    labelId="IFSP.SaveFirstPage"
                    defaultLabelId="Save First Page"
                    variantType="contained"
                    onClick={() => {
                      handleAddOrUpdateIfspDetails();
                    }}
                  />
                </Box>
              </Box>
              <Box ref={autoScrollRef}>
                <IfspTabNavigationComponent
                  ifspFirstMeetingDate={
                    originalIfspClientDetails.ifspFirstMeetingDate || ''
                  }
                  openTransitionPlanningTab={state?.openTransitionPlanning}
                />
              </Box>
            </Card>
          )}
        </Box>
        {!isIfspInitiated && (
          <EmptyScreen
            titleLabelId={'IFSP.NotInitiatedTitle'}
            defaultTitleText="IFSP not initiated yet"
            showButton={ifspPermission.hasClientEditPermission}
            buttonLabelId="IFSP.InitiateButtonTitle"
            defaultButtonTitleText="Initiate IFSP"
            onButtonClick={() => setIfspInitiateAlert(true)}
            className="mb-md"
          />
        )}
      </TranslateWidget>
    </Box>
  );
};

export default IfspMainScreen;
